export const GoogleIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.54 8.16406C15.54 7.64406 15.4933 7.14406 15.4067 6.66406H8.5V9.50406H12.4467C12.2733 10.4174 11.7533 11.1907 10.9733 11.7107V13.5574H13.3533C14.74 12.2774 15.54 10.3974 15.54 8.16406Z"
      fill="#4285F4"
    />
    <path
      d="M8.49979 15.3318C10.4798 15.3318 12.1398 14.6784 13.3531 13.5584L10.9731 11.7118C10.3198 12.1518 9.48646 12.4184 8.49979 12.4184C6.59312 12.4184 4.97313 11.1318 4.39313 9.39844H1.95312V11.2918C3.15979 13.6851 5.63312 15.3318 8.49979 15.3318Z"
      fill="#34A853"
    />
    <path
      d="M4.39268 9.39094C4.24602 8.95094 4.15935 8.48427 4.15935 7.9976C4.15935 7.51094 4.24602 7.04427 4.39268 6.60427V4.71094H1.95268C1.45268 5.6976 1.16602 6.81094 1.16602 7.9976C1.16602 9.18427 1.45268 10.2976 1.95268 11.2843L3.85268 9.80427L4.39268 9.39094Z"
      fill="#FBBC05"
    />
    <path
      d="M8.49979 3.58406C9.57979 3.58406 10.5398 3.9574 11.3065 4.6774L13.4065 2.5774C12.1331 1.39073 10.4798 0.664062 8.49979 0.664062C5.63312 0.664062 3.15979 2.31073 1.95312 4.71073L4.39313 6.60406C4.97313 4.87073 6.59312 3.58406 8.49979 3.58406Z"
      fill="#EA4335"
    />
  </svg>
);
